import React from 'react';
import {
	ColorPickerField,
	InputWithUnitField,
	SelectField,
} from '@extensions/components/Form';
// Hidden imports for disabled features:
// import { TextAreaField } from '@extensions/components/Form';
// import { AddFont } from '@extensions/components/Form/AddFont';
import { Collapse, Grid } from '@arco-design/web-react';
import { Stack, useFocusIdx, useEditorProps } from '@bay-email/editor';
import { t } from '@bay-email/core';
import { AttributesPanelWrapper } from '@extensions/AttributePanel/components/attributes/AttributesPanelWrapper';
import { FontFamily } from '../../attributes/FontFamily';
import { LineHeight } from '../../attributes/LineHeight';
import { pixelAdapter } from '../../adapter';
import { BsChevronDown } from 'react-icons/bs';

export function Page() {
	const { focusIdx } = useFocusIdx();
	const { blockMode } = useEditorProps();

	if (!focusIdx) return null;

	// Block editor variant: a block must inherit global background colors and
	// fonts from the email template it's dropped into, so it can't dictate
	// page-level settings. Suppress the Page attributes entirely.
	if (blockMode) return null;

	return (
		<AttributesPanelWrapper style={{ padding: 0 }}>
			<Stack.Item fill>
				<Collapse expandIconPosition='right' expandIcon={<BsChevronDown size='1rem' />} defaultActiveKey={['0']}>
					<Collapse.Item
						name='0'
						header={t('Default Page Settings')}
						contentStyle={{ padding: 0 }}
					>
						<div className='p-3'>
							{/* Subject and SubTitle moved to SubjectPreviewPanel */}
							{/* Width and Breakpoint fields hidden per user request */}
							{/*
              <InputWithUnitField
                label={t('Width')}
                name={`${focusIdx}.attributes.width`}
                inline
                readOnly
                disabled
              />
              <InputWithUnitField
                label={t('Breakpoint')}
                helpText={t(
                  'Allows you to control on which breakpoint the layout should go desktop/mobile.',
                )}
                name={`${focusIdx}.data.value.breakpoint`}
                inline
                readOnly
                disabled
              />
              */}
							<Stack
								vertical
								spacing='tight'
							>
									<Grid.Row gutter={16}>
									<Grid.Col span={12}>
										<ColorPickerField
											label={t('Background')}
											name={`${focusIdx}.attributes.background-color`}
										/>
									</Grid.Col>
									<Grid.Col span={12}>
										<ColorPickerField
											label={t('Content Background')}
											name={`${focusIdx}.data.value.content-background-color`}
										/>
									</Grid.Col>
								<Grid.Col span={12}>
										<ColorPickerField
											label={t('Text Color')}
											name={`${focusIdx}.data.value.text-color`}
										/>
									</Grid.Col>
								</Grid.Row>

								{/* Font Family - Full Width */}
								<FontFamily name={`${focusIdx}.data.value.font-family`} />

								{/* Typography inputs */}
								<Grid.Row gutter={16}>
									<Grid.Col span={12}>
										<InputWithUnitField
											label={t('Font Size (px)')}
											name={`${focusIdx}.data.value.font-size`}
											config={pixelAdapter}
											autoComplete='off'
										/>
									</Grid.Col>
									<Grid.Col span={12}>
										<LineHeight name={`${focusIdx}.data.value.line-height`} />
									</Grid.Col>
								</Grid.Row>

								<Grid.Row gutter={16}>
									<Grid.Col span={12}>
										<SelectField
											label={t('Font Weight')}
											name={`${focusIdx}.data.value.font-weight`}
											className='custom-select-right-caret'
											options={[
												{ label: t('Normal'), value: 'normal' },
												{ label: t('Bold'), value: 'bold' },
												{ label: '100', value: '100' },
												{ label: '200', value: '200' },
												{ label: '300', value: '300' },
												{ label: '400', value: '400' },
												{ label: '500', value: '500' },
												{ label: '600', value: '600' },
												{ label: '700', value: '700' },
												{ label: '800', value: '800' },
												{ label: '900', value: '900' },
											]}
										/>
									</Grid.Col>
								</Grid.Row>

								{/* Hidden: Custom CSS and Font importing
              <TextAreaField
                autoSize
                label={t('User style')}
                name={`${focusIdx}.data.value.user-style.content`}
              />
              <Stack.Item />
              <Stack.Item />
              <AddFont />
              <Stack.Item />
              <Stack.Item />
              */}
							</Stack>
						</div>
					</Collapse.Item>
				</Collapse>
			</Stack.Item>
		</AttributesPanelWrapper>
	);
}
